import React, { useEffect, useState } from 'react';
import ElectronicHealthCardContactInfo from '../../../Nczi/Components/ElectronicHealthCard/ContactInfo/ElectronicHealthCardContactInfo';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import ElectronicHealthCardSummary from '../../../Nczi/Components/ElectronicHealthCard/Summary/ElectronicHealthCardSummary';
import NCZIPatient from '../../../Nczi/Components/NCZIPatient/NCZIPatient';

interface Props {
	patientId: string;
	setIsLoading: (isLoading: boolean) => void;
}

const ElectronicHealthCard: React.FC<Props> = ({ patientId, setIsLoading }) => {
	const [steps, setSteps] = useState<NavigationStepperItemType[]>([]);

	useEffect(() => {
		handleLoadSteps();
	}, []);

	const handleLoadSteps = () => {
		const tempSteps: NavigationStepperItemType[] = [
			{
				name: 'patientTreatment.ezk.contactInfo.title',
				key: 'contactInfo',
				component: (params: NavigationStepperComponentParams) => (
					<NCZIPatient>
						<ElectronicHealthCardContactInfo setIsLoading={setIsLoading} />
					</NCZIPatient>
				),
			},
			{
				name: 'patientTreatment.ezk.summary.title',
				key: 'summary',
				component: (params: NavigationStepperComponentParams) => (
					<NCZIPatient>
						<ElectronicHealthCardSummary setIsLoading={setIsLoading} />
					</NCZIPatient>
				),
			},
		];

		setSteps(tempSteps);
	};

	if (!steps.length) {
		return <></>;
	}

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='contactInfo'
				canSkip={true}
			/>
		</>
	);
};

export default ElectronicHealthCard;
